import React, { useState, useEffect } from 'react';
import styles from './EditMessagePopup.module.css';
import { MessageType, EditMessageProps } from '../../types/message';

const EditMessagePopup: React.FC<EditMessageProps> = ({ 
  message,
  onSave,
  onClose,
  isVisible
}) => {
  const [content, setContent] = useState<string>(message.content);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  // Reset content when message changes
  useEffect(() => {
    setContent(message.content);
  }, [message.content]);

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (content.trim() === message.content) {
      onClose();
      return;
    }

    setIsSaving(true);
    try {
      await onSave(content.trim());
      onClose();
    } catch (err) {
      console.error('Failed to save message:', err);
      // Could add error state handling here
    } finally {
      setIsSaving(false);
    }
  };

  if (!isVisible) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div 
        className={styles.popup}
        onClick={e => e.stopPropagation()}
      >
        <div className={styles.header}>
          <h3>Edit Message</h3>
          <button className={styles.closeButton} onClick={onClose} disabled={isSaving}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            className={styles.textarea}
            autoFocus
            disabled={isSaving}
          />
          <div className={styles.buttons}>
            <button 
              type="button" 
              onClick={onClose} 
              className={styles.cancelButton}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className={`${styles.saveButton} ${isSaving ? styles.saving : ''}`}
              disabled={content.trim() === message.content || isSaving}
            >
              {isSaving ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditMessagePopup; 